import { Component } from '@angular/core';

@Component({
  selector: 'app-inventory-icon',
  imports: [],
  templateUrl: './inventory-icon.html',
  styleUrl: './inventory-icon.css'
})
export class InventoryIcon {

}
